<div mat-dialog-title>Logga in på Gitlab</div>
<mat-dialog-content>
  <p>Tryck logga in nedan för att logga in på GitLab och hämta ett åtkomstbevis.</p>
  <p>Efter inloggning kommer du till deploysidan.</p>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-dialog-close matButton="text">Avbryt</button>
  <button (click)="login()" class="gitlab"
          matButton="outlined">Logga in
  </button>
</mat-dialog-actions>
